import 'reflect-metadata';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';
import 'material-icons/iconfont/material-icons.css';
import 'rc-slider/assets/index.css';
import './index.scss';
import './i18n/i18n';
import i18next from 'i18next';
import { I18nextProvider } from 'react-i18next';
import { ServiceContainer } from 'react-service-locator';

ReactDOM.render(
    <React.StrictMode>
        <I18nextProvider i18n={i18next}>
            <ServiceContainer>
                <App />
            </ServiceContainer>
        </I18nextProvider>
    </React.StrictMode>,
    document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
